// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../../shared/components/checkbox-list-with-label';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';

const ClaimStatusCriteria = props => {

    const buttonLabel = props.selectedStatuses.length ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (
        <div className='claim-status-criteria'>
            <CheckboxListWithLabel
                className='claim-statuses'
                initialState={createHashMap(props.selectedStatuses, 'key')}
                isRequired={true}
                label='STATUS'
                list={addCollectionLabels(props.allowedStatuses, 'value')}
                onChange={props.onClaimStatusSelect}
                uid='key'
            />
            <button
                className='toggle-all'
                onClick={props.onAllClaimStatusesSelect}
                type='button'
            >
                <FormattedMessage id={buttonLabel}/>
            </button>
        </div>
    );

};

ClaimStatusCriteria.displayName = 'ClaimStatusCriteria';
ClaimStatusCriteria.propTypes = {
    allowedStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onAllClaimStatusesSelect: PropTypes.func.isRequired,
    onClaimStatusSelect: PropTypes.func.isRequired,
    selectedStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default ClaimStatusCriteria;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/components/report-criteria/claim-status-criteria.js